<template>
  <product-shop-the-look
    v-if="$feature.pdpShopTheLookElevated"
    :product-sets="product?.productSets"
    @open-shop-the-look="openShopTheLook($event)"
  />
  <product-shop-the-look-original v-else />
</template>

<script setup lang="ts">
const { openShopTheLook, product } = usePdp()
</script>
